module.exports = __webpack_public_path__ + "media/application/images/icons/eye-47d574fa5c6a713f7857af141347462e.svg";